import React, { useState } from "react";
import { db, storage } from "../../lib/firebase";
import { collection, doc, serverTimestamp, setDoc } from "firebase/firestore";
import { ref, uploadBytes, getDownloadURL } from "firebase/storage";
import { useNavigate } from "react-router-dom";

const label = { display:"block", margin:"14px 0 6px", opacity:.9 };
const input = { width:"100%", padding:12, borderRadius:12, border:"1px solid rgba(255,209,59,.3)", background:"rgba(0,0,0,.35)", color:"#e9eef5" };
const btn   = { marginTop:16, background:"#ffd13b", color:"#0b0f14", padding:"12px 18px", borderRadius:999, fontWeight:800, border:"none", cursor:"pointer" };

export default function NewPost(){
  const nav = useNavigate();
  const [title, setTitle] = useState("");
  const [slug, setSlug] = useState("");
  const [excerpt, setExcerpt] = useState("");
  const [content, setContent] = useState("");
  const [file, setFile] = useState(null);
  const [saving, setSaving] = useState(false);

  const handleTitle = (v) => {
    setTitle(v);
    if (!slug) {
      const s = v.toLowerCase().replace(/[^a-z0-9]+/g,"-").replace(/(^-|-$)/g,"");
      setSlug(s);
    }
  };

  const submit = async (e) => {
    e.preventDefault();
    if (!title) return;
    setSaving(true);
    try {
      let coverUrl = "";
      if (file) {
        const r = ref(storage, `covers/${slug}-${Date.now()}`);
        await uploadBytes(r, file);
        coverUrl = await getDownloadURL(r);
      }
      await setDoc(doc(collection(db, "posts"), slug || "post"), {
        title, slug, excerpt, content, coverUrl,
        status: "published",
        publishedAt: serverTimestamp()
      });
      nav(`/blog/${slug}`);
    } finally { setSaving(false); }
  };

  return (
    <form onSubmit={submit} style={{ maxWidth: 900, margin:"90px auto", padding:"0 18px", color:"#e9eef5" }}>
      <h1 style={{ color:"#ffd13b" }}>New Post</h1>
      <label style={label}>Title</label>
      <input style={input} value={title} onChange={e=>handleTitle(e.target.value)} />
      <label style={label}>Slug</label>
      <input style={input} value={slug} onChange={e=>setSlug(e.target.value)} />
      <label style={label}>Excerpt</label>
      <textarea style={input} rows={3} value={excerpt} onChange={e=>setExcerpt(e.target.value)} />
      <label style={label}>Cover Image</label>
      <input type="file" accept="image/*" onChange={e=>setFile(e.target.files?.[0]||null)} style={{ color:"#e9eef5" }}/>
      <label style={label}>Content (Markdown)</label>
      <textarea style={input} rows={12} value={content} onChange={e=>setContent(e.target.value)} />
      <button disabled={saving} style={btn}>{saving ? "Publishing..." : "Publish"}</button>
    </form>
  );
}
